import { render, staticRenderFns } from "./AlarmMaskDurationInput.vue?vue&type=template&id=676ec72a"
import script from "./AlarmMaskDurationInput.vue?vue&type=script&lang=ts"
export * from "./AlarmMaskDurationInput.vue?vue&type=script&lang=ts"
import style0 from "./AlarmMaskDurationInput.vue?vue&type=style&index=0&id=676ec72a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports